import React from 'react';
import * as Styled from './styled';
import ErrorPage from './ErrorPage';
import { AEMContent } from '@mlc/web-ui-toolkit';

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends React.Component<{}, State> {
	constructor(props: any) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: any) {
		return { hasError: true };
	}

	componentDidCatch(error: any, info: any) {}

	render() {
		return this.state.hasError ? <Error /> : this.props.children;
	}
}

const Error = () => (
	<ErrorPage message="Something went wrong">
		<Styled.ErrorMessage>
			<AEMContent path="/secure/_content/Adviser/error-message" />
		</Styled.ErrorMessage>
	</ErrorPage>
);

export default ErrorBoundary;
